import React, { useState } from "react";
import PropTypes from "prop-types";
import { CreateHotJarContextProvider } from "./context";

export const HotJarProvider = ({ children }) => {
  const [isHotJarStarted, setIsHotJarStarted] = useState(false);

  return (
    <CreateHotJarContextProvider
      value={{
        isHotJarStarted,
        setIsHotJarStarted,
      }}
    >
      {children}
    </CreateHotJarContextProvider>
  );
};

HotJarProvider.propTypes = {
  children: PropTypes.any,
};
